import { createGlobalStyle } from 'styled-components'

export const VideoStyle = createGlobalStyle`
:root {
  --content-width: min(80vw, 500px);
}

iframe {
    width: var(--content-width);
    height: calc(var(--content-width) / 1.78);  
}

.Home {
  height: 100vh;
}
`